import { useEffect } from "react";
import { useEventCallback } from "usehooks-ts";
import { useApplication } from "@pixi/react";
export const usePixiMouseEventListener = (handler, ref, capture = false, on = "mousedown") => {
    const app = useApplication();
    const eventHandler = useEventCallback(handler);
    useEffect(() => {
        if (ref && ref.current === null) {
            return undefined;
        }
        const abortController = new AbortController();
        const element = ref?.current ?? app.app.stage;
        element.addEventListener(on, eventHandler, { capture, signal: abortController.signal });
        return () => {
            abortController.abort();
        };
    }, [capture, ref, on, app.app.stage, eventHandler]);
};
//# sourceMappingURL=usePixiMouseEventListener.js.map